import DOMPurify = require('dompurify');
export function getQueryValue(key: string, queryString?: string): string | undefined {
  if (!queryString) {
    queryString = window.location.search.substring(1);
  }
  const vars = queryString.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === key) {
      return DOMPurify.sanitize(decodeURIComponent(pair[1]));
    }
  }
}

export default getQueryValue;
